import { getCurrencyList } from "@/services/sso.service";

// initial state
const state = () => ({});

// mutations
const mutations = {};

// actions
const actions = {
  async loadCurrencies() {
    return await getCurrencyList().then((response) => {
      let data = response.data.data;
      return data;
    });
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
